import { render, staticRenderFns } from "./Finishings.vue?vue&type=template&id=06a5ebce&"
import script from "./Finishings.vue?vue&type=script&lang=js&"
export * from "./Finishings.vue?vue&type=script&lang=js&"
import style0 from "./Finishings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports